const timeFast = 500;
const timeSlow = 2000;
const styleBorder = "1px solid darkgray";

export const getTimeFast = () => {
  return timeFast;
};

export const getTimeSlow = () => {
  return timeSlow;
};

export const getBorder = () => {
  return styleBorder;
};
